/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_FullscreenInputs */

const en_fc_online_fullscreen = /** @type {(inputs: Fc_Online_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open full screen`)
};

/**
* | output |
* | --- |
* | "Open full screen" |
*
* @param {Fc_Online_FullscreenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_fullscreen = /** @type {((inputs?: Fc_Online_FullscreenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_FullscreenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_fullscreen(inputs)
});
export { fc_online_fullscreen as "fc.online.fullscreen" }